export default "__VITE_ASSET__63d5b00d__"